import { render } from "./PrintInstallmentTableDesign2.vue?vue&type=template&id=0f87bafc&scoped=true"
import script from "./PrintInstallmentTableDesign2.vue?vue&type=script&lang=js"
export * from "./PrintInstallmentTableDesign2.vue?vue&type=script&lang=js"

import "./PrintInstallmentTableDesign2.vue?vue&type=style&index=0&id=0f87bafc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f87bafc"]])

export default __exports__